export default __webpack_public_path__ + "static/media/Smart_plug.5524e129.svg";